import { type Option } from '@allesauto/core/searchDropdown';
import { consts } from '@allesauto/utils/consts';

import {
  RESET_FILTER_LOCATION,
  SET_FILTER_LOCATION,
} from '@/store/redux/actions/pages/pcp';
import { IReduxActionProps } from '@/store/redux/Utils';

export interface LocationStateProps {
  location?: Option;
  radius: number;
  latitude?: number;
  longitude?: number;
  filterCount: number;
}

export const InitialLocationState: LocationStateProps = {
  location: undefined,
  radius: consts.PCP.FILTERS.LOCATION_RADIUS_DEFAULT,
  latitude: undefined,
  longitude: undefined,
  filterCount: 0,
};

const LocationState = (
  state: LocationStateProps = InitialLocationState,
  action: IReduxActionProps
) => {
  switch (action.type) {
    case SET_FILTER_LOCATION: {
      const newProps = action.payload as LocationStateProps;

      return {
        ...state,
        ...newProps,
        filterCount: 1,
      };
    }
    case RESET_FILTER_LOCATION:
      return { ...InitialLocationState };
    default:
      return state;
  }
};

export default LocationState;
